import {useState} from 'react';
import {useToast} from '../contexts/ToastContext';
import {useTranslation} from 'react-i18next';

interface ApiError {
  response?: {
    status: number;
    data?: {
      details?: Record<string, string>;
      message?: string;
    };
  };
}

export const useFormErrorHandling = () => {
  const [errors, setErrors] = useState<Record<string, string>>({});
  const {showError} = useToast();
  const {t} = useTranslation();

  const handleApiError = (error: unknown) => {
    const apiError = error as ApiError;
    if (apiError.response?.status === 400 && apiError.response.data?.details) {
      setErrors(apiError.response.data.details);
      showError(t('admin.common.validationFailed'), t('admin.common.checkFields'));
    } else {
      showError(t('admin.common.error'), t('admin.common.genericErrorMessage'));
      console.error('API Error:', error);
    }
  };

  const clearErrors = () => {
    setErrors({});
  };

  return {
    errors,
    setErrors,
    handleApiError,
    clearErrors
  };
};
